<template>
	<div class="mm-page-main">买入交易</div>
</template>

<script>

	export default {
		data() {
			return {
				
			};
		}
		
	};
</script>
